const newArea = {
  snackbar: "Your update is ready",
  name: "Facility Name",
  save: "Save",
  cancel: "Cancel",
  area: "Facility",
  formTitle: "New Facility",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete",
  selectCompany: "Select a Company"
};
export default newArea;
